<template>
    <div class="mit-explore-storage-page mit-page">
        <v-container fluid>
        <v-row no-gutters>
          <v-col cols="12" class="d-flex">
            <v-card class="mit-info-card">
              <v-card-title>Explore Volumes<v-spacer></v-spacer><MitVolumeUnit/></v-card-title>
              <v-card-subtitle class="caption">Explore CSAIL Volumes</v-card-subtitle>
              <v-divider></v-divider>
                <MitVolumesExplore></MitVolumesExplore>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
</template>

<script>
  import MitVolumesExplore from '../components/MitVolumesExplore.vue';
  import MitVolumeUnit from '../components/MitVolumeUnit.vue';

  export default {
    name: 'MitExploreStoragePage',
    components: {
      MitVolumesExplore,
      MitVolumeUnit
    },
    data: function() {
      return {
      }
    },
    props: {
      userModel: Object, //comes from route
      userRoles: Object //comes from route
    },
    created() {

    },
    methods: {
      test(){

      }
    }
  }
</script>

<style lang="scss" scoped>
  .mit-info-card {
    width:100%;
    height:100%;
  }
  .mit-table {
    padding-top: 30px;
    padding-bottom: 30px;
  }
  .mit-my-borrowed-list {
    padding-bottom: 30px;
  }
</style>
